'use client';

import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '../../../../../../shared/cn';
import { ManageAttachments, ViewAttachments } from '../../Attachments';
import type { AttachmentFile } from '../../Attachments/types';
type SplitViewEditorProps = {
  editorReady: boolean;
  previewReady: boolean;
  EditorSection: React.ReactNode;
  PreviewSection: React.ReactNode;
  height?: number;
  markdownOnly?: boolean;
  files?: AttachmentFile[];
  setFiles?: (files: AttachmentFile[]) => void;
  disabled?: boolean;
};
export const SplitViewEditor = t0 => {
  const $ = _c(23);
  const {
    editorReady,
    previewReady,
    EditorSection,
    PreviewSection,
    height,
    markdownOnly: t1,
    files: t2,
    setFiles,
    disabled: t3
  } = t0;
  const markdownOnly = t1 === undefined ? false : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const files = t4;
  const disabled = t3 === undefined ? false : t3;
  const isReady = editorReady && previewReady;
  const t5 = isReady ? "opacity-100" : "pointer-events-none opacity-0";
  let t6;
  if ($[2] !== t5) {
    t6 = cn("flex w-full flex-col gap-2 transition-opacity duration-150", t5);
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const t7 = `${height}rem`;
  let t8;
  if ($[4] !== t7) {
    t8 = {
      height: t7
    };
    $[4] = t7;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== EditorSection) {
    t9 = <div className="bg-backgroundSecondary border-borderPrimary h-full flex-1 min-w-0 rounded-lg border">{EditorSection}</div>;
    $[6] = EditorSection;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== PreviewSection) {
    t10 = <div className="bg-backgroundSecondary border-borderPrimary h-full flex-1 min-w-0 rounded-lg border">{PreviewSection}</div>;
    $[8] = PreviewSection;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t8 || $[12] !== t9) {
    t11 = <div className="flex gap-2" style={t8}>{t9}{t10}</div>;
    $[10] = t10;
    $[11] = t8;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== disabled || $[15] !== files || $[16] !== markdownOnly || $[17] !== setFiles) {
    t12 = !markdownOnly && setFiles ? <div className="flex gap-4"><div className="flex flex-1 flex-col gap-2"><ManageAttachments files={files} setFiles={setFiles} disabled={disabled} /></div><div className="flex flex-1 flex-col gap-2"><ViewAttachments files={files} /></div></div> : null;
    $[14] = disabled;
    $[15] = files;
    $[16] = markdownOnly;
    $[17] = setFiles;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12 || $[21] !== t6) {
    t13 = <div className={t6}>{t11}{t12}</div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t6;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  return t13;
};